/* eslint-disable @typescript-eslint/no-unused-vars */
import { createCommunityRemix } from 'lib/analytics';
import { createRemix } from 'lib/api/community_api';
import { createRemixAndOpen } from 'lib/remixes';
import { VoidCallback } from 'types/callbacks';
import { CommunityShotItem } from 'types/community';
import RemixModalContainer, {
  RemixModalActions,
  WhatIsRemixing,
} from './RemixModalContainer';
import { TeamResponse } from 'lib/teams';
import { useEffect, useState } from 'react';
import TeamSelection from './TeamSelection';

type Props = {
  display: boolean;
  onClose: VoidCallback;
  onCreate: VoidCallback;
  shotItem: CommunityShotItem;
  teams: TeamResponse[];
};

export default function StandardRemixModal({
  display,
  onClose,
  onCreate,
  shotItem,
  teams,
}: Props) {
  const [selectedTeam, selectTeam] = useState(
    teams !== undefined && teams.length > 0 ? teams[0] : undefined
  );

  useEffect(() => {
    const validTeams = teams !== undefined && teams.length > 0;
    const validSelection =
      selectedTeam !== undefined &&
      teams.find((team) => team.ownerId === selectedTeam.ownerId);
    if (validTeams && !validSelection) {
      selectTeam(teams[0]);
    }
  }, [teams]);

  function onSaveForLaterClick() {
    const teamId = selectedTeam?.ownerId;
    if (teamId) {
      createRemix(teamId, shotItem.revisionId, shotItem.title).then((remix) => {
        onCreate && onCreate();
        if (remix.remix) {
          createCommunityRemix(
            shotItem.communityPostId,
            shotItem.fileId,
            shotItem.title,
            shotItem.isRemix,
            remix.remix.fileId,
            'save_for_later'
          );
        }
      });
      onClose();
    }
  }

  function onStartEditingClick() {
    const teamId = selectedTeam?.ownerId;
    if (teamId) {
      createRemixAndOpen(teamId, shotItem.revisionId, shotItem.title).then(
        (remix) => {
          if (remix) {
            createCommunityRemix(
              shotItem.communityPostId,
              shotItem.fileId,
              shotItem.title,
              shotItem.isRemix,
              remix.fileId,
              'start_editing'
            );
          }
          onClose();
        }
      );
    }
  }

  return (
    <RemixModalContainer display={display} onClose={onClose}>
      <h1>Remix</h1>
      <WhatIsRemixing />
      <TeamSelection
        teams={teams}
        selectTeam={selectTeam}
        selectedTeam={selectedTeam}
      />
      <RemixModalActions>
        <button
          disabled={selectedTeam?.ownerId === undefined}
          onClick={onSaveForLaterClick}
        >
          Save for Later
        </button>
        <button
          disabled={selectedTeam?.ownerId === undefined}
          onClick={onStartEditingClick}
        >
          Start editing
        </button>
      </RemixModalActions>
    </RemixModalContainer>
  );
}
